import React, { useState } from 'react';
import { string, node, bool, shape } from 'prop-types';
import { useThumbnailUrl } from 'components/video-generating/use-thumbnail-url';
import { VideoItemGeneratingThumbnail } from 'components/video-generating/video-generating-thumbnail';
import { VideoItemGeneratedThumbnail } from './video-generated-thumbnail';

export const VideoItemThumbnail = ({ url, video, children }) => {
  const [isHovered, setHovered] = useState(false);
  const thumbnailUrl = useThumbnailUrl(video);

  return thumbnailUrl ? (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <VideoItemGeneratedThumbnail thumbnailUrl={thumbnailUrl} url={url} videoId={video.id} isHovered={isHovered}>
        {children}
      </VideoItemGeneratedThumbnail>
    </div>
  ) : (
    <VideoItemGeneratingThumbnail />
  );
};

VideoItemThumbnail.propTypes = {
  url: string,
  children: node,
  video: shape({
    id: string.isRequired,
    playable: bool,
    thumbnail: shape({
      url: string,
    }),
    displayDate: string,
  }).isRequired,
};
